import { createContext } from "react";

const TeacherAttendanceContext = createContext();

export default TeacherAttendanceContext;